module.exports = __webpack_public_path__ + "assets/img/instant-and-manual-confirmation.jpg";